import type { LevelDefinition } from '../world/LevelDefinition';

const surfaces = {
  floor: { enabled: true, magnetic: true },
  ceiling: { enabled: true, magnetic: true },
  left: { enabled: true, magnetic: true },
  right: { enabled: true, magnetic: true },
  front: { enabled: true, magnetic: true },
  back: { enabled: true, magnetic: true },
};

const ceilingLights = (positions: Array<[number, number]>) =>
  positions.map(([x, z]) => ({
    position: [x, 3.9, z] as [number, number, number],
    size: [2, 0.08, 1.2] as [number, number, number],
  }));

/**
 * Junction 12: a four-way hub with a corridor on each compass point. The first
 * level where every fight can come from a different branch.
 */
export const JUNCTION_12: LevelDefinition = {
  id: 'junction12',
  name: 'Junction 12',
  size: [48, 4, 48],
  surfaces,
  zones: [
    { id: 'hub', origin: [0, 0, 0], size: [10, 4, 10] },
    { id: 'north', origin: [0, 0, -13], size: [8, 4, 16] },
    { id: 'south', origin: [0, 0, 13], size: [8, 4, 16] },
    { id: 'east', origin: [13, 0, 0], size: [16, 4, 8] },
    { id: 'west', origin: [-13, 0, 0], size: [16, 4, 8] },
  ],
  portals: [
    { id: 'hub-north', a: 'hub', b: 'north', axis: 'x', position: [0, 0, -5], width: 3, height: 3 },
    { id: 'hub-south', a: 'hub', b: 'south', axis: 'x', position: [0, 0, 5], width: 3, height: 3 },
    { id: 'hub-east', a: 'hub', b: 'east', axis: 'z', position: [5, 0, 0], width: 3, height: 3 },
    { id: 'hub-west', a: 'hub', b: 'west', axis: 'z', position: [-5, 0, 0], width: 3, height: 3 },
  ],
  spawn: { zone: 'hub', surface: 'floor', position: [0, 0, 3], facing: 0 },
  targets: [
    { type: 'drone', zone: 'hub', surface: 'floor', position: [0, 0, 0] },
    { type: 'drone', zone: 'north', surface: 'floor', position: [0, 0, -16] },
    { type: 'drone', zone: 'south', surface: 'floor', position: [0, 0, 16] },
    { type: 'drone', zone: 'east', surface: 'floor', position: [17, 0, 0] },
    { type: 'drone', zone: 'west', surface: 'floor', position: [-17, 0, 0] },
    { type: 'drone', zone: 'hub', surface: 'ceiling', position: [0, 4, 0] },
    { type: 'drone', zone: 'east', surface: 'ceiling', position: [14, 4, 0] },
  ],
  obstacles: [
    {
      type: 'box',
      kind: 'console',
      zone: 'hub',
      position: [3.2, 0.55, -3.2],
      size: [2.4, 1.1, 0.9],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'hub',
      position: [-3.2, 0.55, 3.2],
      size: [2.4, 1.1, 0.9],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'hub',
      position: [-3.2, 0.55, -3.2],
      size: [2.4, 1.1, 0.9],
    },
    {
      type: 'box',
      kind: 'console',
      zone: 'hub',
      position: [3.2, 0.55, 3.2],
      size: [2.4, 1.1, 0.9],
    },
    { type: 'box', kind: 'pillar', zone: 'north', position: [3, 2, -8], size: [1, 4, 1] },
    { type: 'box', kind: 'pillar', zone: 'south', position: [-3, 2, 8], size: [1, 4, 1] },
    { type: 'box', kind: 'pillar', zone: 'east', position: [8, 2, 3], size: [1, 4, 1] },
    { type: 'box', kind: 'pillar', zone: 'west', position: [-8, 2, -3], size: [1, 4, 1] },
  ],
  style: {
    wallColor: 0x2a3038,
    floorColor: 0x1b2026,
    ceilingColor: 0xc9d6e2,
    pathColor: 0xffb347,
    path: [
      { from: [0, -20], to: [0, 20], width: 2.4 },
      { from: [-20, 0], to: [20, 0], width: 2.4 },
    ],
    ceilingLights: ceilingLights([
      [0, -17],
      [0, -8],
      [0, 0],
      [0, 8],
      [0, 17],
      [-17, 0],
      [-8, 0],
      [8, 0],
      [17, 0],
    ]),
  },
  seed: 6145,
};
